import { VisualisationGatewayService } from 'CommonData/services/visualisationGateway.service';
import { LayingPatternViewer } from './layingPatternViewer';

export class AppInteraction {
    public static async submit(overallM2IncWastage: number = 0) {
        const currentTexture: any = LayingPatternViewer.getCurrentTexture();

        await VisualisationGatewayService.postAppInteraction(
            currentTexture.PatternId, 
            overallM2IncWastage, 
            currentTexture.ProductTextureKey,
            `${currentTexture.JointWidthMM}_${currentTexture.JointTextureKey}_${currentTexture.MaskId}_${currentTexture.PatternId}`
        );
    }
}